import Box from "@mui/material/Box";
import { Divider, styled } from "@mui/material";
import { useTranslation } from "react-i18next";

const HeaderText = styled("p")({
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "24px",
});

const CustomDivider = styled(Divider)(({ theme }) => ({
  marginTop: "16px",
  borderColor: "#cccccc",
}));

const HowToBuyOnline = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <HeaderText>ნივთის ონლაინ ყიდვის ინსტრუქცია</HeaderText>
      <CustomDivider />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          marginTop: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <b>
            1. გაიარე რეგისტრაცია, სრულად შეავსე შენი პროფილი პირადი
            ინფორმაციით. თუ უკვე დარეგისტრირებული ხარ, გაიარეთ ავტორიზაცია -
            მეილით.
          </b>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <b>
            2. Რეგისტრაციის გავლის შემდეგ ვებგვერდზე შეარჩიე სასურველი ნივთი და
            აირჩიე ღილაკი “ყიდვა”
          </b>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <b>
            3. აირჩიე მიწოდების მეთოდი და ტიპი. მიუთითე ყველა საჭირო ინფორმაცია
          </b>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <b>4. არიჩიე გადახდის მეთოდი და დაადასტურე</b>
        </div>
      </div>
    </Box>
  );
};

export default HowToBuyOnline;
